export default "__VITE_ASSET__wS1wxtZk__"